import {Component, OnInit} from '@angular/core';
import {MagazzinoService} from "../../../services/magazzino.service";
import {ImpreseService} from "../../../services/imprese.service";
import {Impresa} from "../../../models/impresa.model";
import {MagazzinoApiDescriptor} from "../../../models/magazzino.model";
import {RegioneDTO} from "../../../models/regione.model";
import {ConfirmationService, MessageService, SelectItem} from "primeng/api";
import {DialogService} from "primeng/dynamicdialog";
import {MagazzinoEditCreateDialogComponent} from "./magazzino-edit-create-dialog/magazzino-edit-create-dialog.component";
import {ActivatedRoute, Router} from "@angular/router";
import {getMagazzinoUserSummary, MagazzinoUserSummary} from "../../../lib/support";

@Component({
	selector: 'app-anagrafica-magazzini',
	templateUrl: './anagrafica-magazzini.component.html',
	styleUrls: ['./anagrafica-magazzini.component.scss'],
	providers: [DialogService, ConfirmationService],

})
export class AnagraficaMagazziniComponent implements OnInit {

	uiReady: boolean;
	dataReady: boolean;

	lockAzienda: Impresa;
	aziendaLockParam: number;

	listingImprese: Impresa[];
	listingRegioni: RegioneDTO[];
	listingMagazzini: CompoMagazzino[];

	filteredMagazzini: CompoMagazzino[];
	textfilter: string;

	// using for debug/superuser
	optionsAzienda: SelectItem<Impresa>[];
	filterAzienda: Impresa;

	userSummary: MagazzinoUserSummary;

	constructor(
		private confirmationService: ConfirmationService,
		private messageService: MessageService,
		public dialogService: DialogService,
		private backendMagazzino: MagazzinoService,
		private impreseService: ImpreseService,
		private route: ActivatedRoute,
		private router: Router
	) {

		this.textfilter = "";
		this.listingRegioni = [];
		this.listingImprese = [];
		this.listingMagazzini = [];
		this.filteredMagazzini = [];

		this.optionsAzienda = [];

		this.lockAzienda = null;

		this.route.params.subscribe((values) => {
			// console.log("changed params to ", values);
			this.reinit();
		})



	}

	reinit () {
		this.userSummary = getMagazzinoUserSummary();
		const canSeeAll = this.userSummary.isSmartFiber || this.userSummary.isPresidio || this.userSummary.isAdmin;
		this.aziendaLockParam = canSeeAll ? (this.route.snapshot.params["aziendaid"] ?? null) : this.userSummary.idImpresa;

		// console.log("azienda lock from url", this.aziendaLockParam, this.route.snapshot.params);

		if (this.aziendaLockParam) {

			this.lockAzienda = this.listingImprese.find((item) => { return item.id == this.aziendaLockParam });
		}

		this.loadData();
	}

	ngOnInit() {
		this.uiReady = true;
	}

	loadData() {

		this.uiReady = false;

		let impreseById = {};
		let regioniById = {};
		let magazziniraw: MagazzinoApiDescriptor[] = [];

		let loaded = {
			imprese: false,
			magazzini: false,
			regioni: false
		};

		const checkUpdateState = () => {
			if (Object.values(loaded).every((value) => value)) {
				this.listingMagazzini = magazziniraw.map((item): CompoMagazzino => {
					return {
						...item,
						azienda: {
							...impreseById[`${item.azienda}`]
						},
						regioni: item.regioni.map((item) => {
							return regioniById[`${item}`]
						}).sort((a: RegioneDTO, b: RegioneDTO) => {
							return a.denominazione.localeCompare(b.denominazione);
						})
					}
				}).sort((a, b) => {
					return a.azienda.ragioneSociale.localeCompare(b.azienda.ragioneSociale) ?? a.codice.localeCompare(b.codice);
				});

				this.lockAzienda = this.aziendaLockParam ? this.listingImprese.find((item) => { return item.id == this.aziendaLockParam}) : null;
				this.filterAzienda = this.lockAzienda;


				this.optionsAzienda = [{
					label: "tutte le imprese",
					value: null
				}, ...this.listingImprese.map((item) => {
					return {
						label: item.ragioneSociale,
						value: item
					}
				})];

				// console.log("composed mags ", this.listingMagazzini);
				this.updateFiltered();
				this.dataReady = true;
			}
		}

		// console.log("getting data for mags list");

		this.impreseService.get().subscribe((result: Impresa[]) => {
			this.listingImprese = result;
			impreseById = {};
			for (let item of result) {
				impreseById[`${item.id}`] = item;
			}
			loaded.imprese = true;
			checkUpdateState();
		});

		this.backendMagazzino.regioneList().subscribe((result) => {
			this.listingRegioni = result.listing;
			regioniById = {};
			for (let item of result.listing) {
				regioniById[`${item.id}`] = item;
			}
			loaded.regioni = true;
			checkUpdateState();
		});

		this.backendMagazzino.magazzinoList().subscribe((result) => {
			// console.log("magazzini: ", result);
			magazziniraw = result.listing;
			loaded.magazzini = true;
			checkUpdateState();
		});
	}

	updateFiltered() {

		this.filteredMagazzini = this.filterAzienda ? this.listingMagazzini.filter((item) => { return item.azienda.id == this.filterAzienda.id; }) : [...this.listingMagazzini];
		this.filterFullText();
	}

	filterFullText() {
		const filterstr = this.textfilter.trim().toLowerCase();
		if (filterstr.length == 0) {
			this.filteredMagazzini = [...this.filteredMagazzini];
		} else {
			this.filteredMagazzini = this.filteredMagazzini.filter((item) => {
				return item.codice.toLowerCase().includes(filterstr) || item.azienda.ragioneSociale.toLowerCase().includes(filterstr);
			});
		}

	}

	getItemEditCreateDialog (compo?: CompoMagazzino) {

		return this.dialogService.open(MagazzinoEditCreateDialogComponent,
			{
				header: !!compo ? `Modifica magazzino ${compo.codice} di ${compo.azienda.ragioneSociale}` : "Crea magazzino",
				modal: true,
				closable: false,
				data: {
					src: compo ?? null,
					imprese: this.listingImprese,
					regioni: this.listingRegioni
				}
			}
		)

	}

	requestItemCreate (item: MagazzinoApiDescriptor) {
		this.backendMagazzino.magazzinoCreate(item).subscribe((result) => {
			this.messageService.add({
				severity: "success",
				detail: `Magazzino ${result.item.codice} creato con successo.`
			})
			this.loadData();
		})
	}

	requestItemUpdate (itemid: string, item: MagazzinoApiDescriptor) {
		this.backendMagazzino.magazzinoUpdate(itemid, item).subscribe((result) => {
			this.messageService.add({
				severity: "success",
				detail: `Magazzino ${result.item.codice} modificato con successo.`
			});
			this.loadData();
		});
	}

	openItemEditCreateDialog (compo?: CompoMagazzino) {

		const ref = this.getItemEditCreateDialog(compo);

		ref.onClose.subscribe((edited: MagazzinoApiDescriptor) => {
			if (edited != null) {
				if (compo != null) {
					this.requestItemUpdate(compo.id, edited);
				} else {
					this.requestItemCreate(edited)
				}
			}
		})
	}

	requestItemDelete (itemid: string) {
		console.warn("PLACEHOLDER - TBA");
		this.backendMagazzino.magazzinoDelete(itemid).subscribe((result) => {
			this.messageService.add({
				severity: "success",
				detail: `Magazzino ${result.item.codice} eliminato con successo.`
			});
			this.loadData();
		});
	}

	openItemDeleteDialog (compo: CompoMagazzino){

		this.confirmationService.confirm({
			// closable: false,
			header: `Conferma eliminazione Magazzino`,
			message: `Vuoi davvero eliminare il magazzino ${compo.codice} di ${compo.azienda.ragioneSociale}?<br>Questa azione non può essere recuperata.`,
			rejectIcon: 'pi pi-times',
			rejectLabel: "Annulla",
			acceptIcon: 'pi pi-check',
			acceptLabel: 'Conferma',
			accept: () => {
				this.requestItemDelete(compo.id);
			},
			reject: () => {
				// do nothing
			}
		});
	}

	openPageScorte (magazzino: CompoMagazzino) {
		this.router.navigate(['/magazzino/scorte/magazzino/' + magazzino.id], { skipLocationChange: true
		});
	}
}

export interface CompoMagazzino {
	id: string;
	codice: string;
	indirizzo: string;
	referente: string;

	azienda: Impresa;
	regioni: RegioneDTO[];

}